import { getStayRoomsFilters, isSameRoomsSplit } from '@koob/utils';
import useTripStore from '../../store/useTripStore';

// Split out of TripDayHotelCard (US-062) to stay under the package's
// max-lines-per-function cap. Whether the two room-editing controls show at
// all (DMC only — TO's defaults leave both always on) and the composition
// modal's save handler, which drops a stale `previousBooking` the moment its
// own rooms no longer match what was actually booked.
export function useTripDayHotelRoomEditing({
  dayIndex,
  hotel,
  tripFilters,
  bookedRooms,
  canMutateHotel,
  readOnly,
}: {
  dayIndex: number;
  hotel: any;
  tripFilters: any;
  bookedRooms: any[];
  canMutateHotel: boolean;
  readOnly: boolean;
}) {
  const updateStayRoomsComposition = useTripStore(
    (state) => state.updateStayRoomsComposition,
  );
  const setHotelInStore = useTripStore((state) => state.setHotel);

  // Editing the fresh room-availability pick makes no sense over an
  // already-booked stay (DMC only): the composition editor stays open so a
  // genuine change can still clear the booking below, but the live picker
  // doesn't get a fresher opinion on rooms the DMC already confirmed.
  const canEditRoomSelection = canMutateHotel && !hotel?.previousBooking;
  const canEditRoomComposition = canMutateHotel && !readOnly;

  // A composition edit that no longer matches what was actually booked means
  // the booked price/rooms fallback no longer applies — the day falls back
  // to a live availability search instead of showing a stale, now-wrong
  // booking.
  const handleSaveRoomsComposition = (rooms: any[]) => {
    if (
      hotel?.previousBooking &&
      !isSameRoomsSplit(
        getStayRoomsFilters(rooms, tripFilters?.composition),
        bookedRooms,
      )
    ) {
      setHotelInStore(hotel.id, { ...hotel, previousBooking: undefined });
    }
    updateStayRoomsComposition(dayIndex, rooms);
  };

  return {
    canEditRoomSelection,
    canEditRoomComposition,
    handleSaveRoomsComposition,
  };
}
